import type { AppConfig } from './types'

/**
 * Static defaults — values that are the same across ALL environments.
 * See src/config/README.md for the full config architecture.
 */
export const defaults = {
  INTERCOM_APP_ID: 'qsqnvucn',
  INTERCOM_ENABLED: true,
  STORAGE_ACCOUNT_URL: 'https://wfpublicassetsstorage.blob.core.windows.net',
  BRANDFETCH_CLIENT_ID: '1idrwVYQKZ5VONiKkzk',
  SENTRY_DSN: 'https://732ae30322884cb386a4136bcc761157@o4504922429063168.ingest.sentry.io/4504922438828032',
  HUBSPOT_PORTAL_ID: '2989273',
  HUBSPOT_REGION: 'na1',
  HUBSPOT_SOURCING_FORM_ID: '5593dabc-e570-44eb-8b14-2f9998d717e4',
  HUBSPOT_FORMS_ENABLED: true,
  CALENDLY_SOURCING_MEETING_URL: 'https://calendly.com/d/dvxc-8yd-56q/talk-to-an-expert',
} satisfies Readonly<Partial<AppConfig>>

/**
 * Dev defaults — used during local development when no runtime config is present.
 * See src/config/README.md for the full config architecture.
 */
export const devDefaults = {
  API_URL: 'https://test.services.worldfavor.com',
  FRONT_ENV: 'dev',
  AUTH0_DOMAIN: 'dev.auth.worldfavor.com',
  AUTH0_CLIENT_ID: 'vegdjaOrErRObUdaLlkApRhnx8HASZdW',
  AUTH0_AUDIENCE: 'https://dev.worldfavor.com',
  INTERCOM_ENABLED: false,
  LAUNCH_DARKLY_CLIENT_SIDE_ID: '63f3c1381c331413af7db054',
  AMPLITUDE_API_KEY: '13c79b517e6388013c098984669490ec',
} satisfies Readonly<Partial<AppConfig>>
